module.exports = __webpack_public_path__ + "static/img/img25.1e18a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img25.png
// module id = +VUx
// module chunks = 1